import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function MerchantLocation({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    address: false,
    landmark: false,
    coordinates: false,
    google_map: false,
    link_type: false,
  });

  // Merchant's Link Type options
  const MERCHANT_LINK_TYPES = [
    "Actual Link of Merchant",
    "Nearby Merchant",
    "Same Street",
    "Barangay"
  ];



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing/selecting
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      address: !primaryDetails.address,
      landmark: !primaryDetails.landmark,
      coordinates: !primaryDetails.coordinates,
      google_map: !primaryDetails.google_map,
      link_type: !primaryDetails.link_type,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };


  const isFormValid = () => {
    return !!primaryDetails.address &&
      !!primaryDetails.landmark &&
      !!primaryDetails.coordinates &&
      !!primaryDetails.google_map &&
      !!primaryDetails.link_type;
  };
  const handleSubmit = () => {
    if (validateForm()) {
      navigation.go("industry-type-store");
    }
  };

  const handleBack = () => {
    // Go back to RegionForm
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">MERCHANT LOCATION</h4>
                <p className="form-desc">Please provide detailed location information</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* <Form.Group className="mb-5" controlId="standalone">
                    <Form.Label className="form-label">
                      Building Name/Standalone <span className="form-required">*</span>
                    </Form.Label>
                    <div>
                      <p className="form-note-text">
                       <em> Put Building name if located in a bldg
                        Put Mall if located in a mall
                        Otherwise, put standalone</em>
                      </p>
                    </div>
                    <Form.Control
                      type="text"
                      name="standalone"
                      value={primaryDetails.standalone || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input${isError.standalone ? " form-input-error" : ""}`}
                    />
                    {isError.standalone && (
                      <div className="form-error">
                        Please enter building name or standalone
                      </div>
                    )}
                  </Form.Group> */}

                  {/* Complete Address */}
                  <Form.Group className="mb-5" controlId="address">
                    <Form.Label className="form-label">
                      Complete Address 
                      <span className="form-required">*</span>
                    </Form.Label>
                    <div>
                      <p className="form-note-text">
                      <em>Include:
                        Room/Unit No./Building Name
                        Street Name, Barangay, City </em>
                      </p>
                    </div>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="address"
                      value={primaryDetails.address || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-textarea${isError.address ? " form-input-error" : ""}`}
                    />
                    {isError.address && (
                      <div className="form-error">
                        Please enter the complete address
                      </div>
                    )}
                  </Form.Group>

                  {/* Landmark (Optional) */}
                  <Form.Group className="mb-5" controlId="landmark">
                    <Form.Label className="form-label">Landmark <span className="form-required">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="landmark"
                      value={primaryDetails.landmark || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input${isError.landmark ? " form-input-error" : ""}`}
                    />
                    {isError.landmark && (
                      <div className="form-error">
                        Please enter the landmark
                      </div>
                    )}
                  </Form.Group>

                  {/* Coordinates (Optional) */}
                  <Form.Group className="mb-5" controlId="coordinates">
                    <Form.Label className="form-label">Coordinates <span className="form-required">*</span></Form.Label>
                    <div>
                      <p className="form-note-text"><em> Ex: 14.6137/121.0194/14.6246/121.0194 </em></p>
                    </div>
                    <Form.Control
                      type="text"
                      name="coordinates"
                      value={primaryDetails.coordinates || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input${isError.coordinates ? " form-input-error" : ""}`}
                    />
                    {isError.coordinates && (
                      <div className="form-error">
                        Please enter the coordinates
                      </div>
                    )}
                  </Form.Group>

                  {/* Merchant's Link in Google Map (Optional) */}
                  <Form.Group className="mb-5" controlId="google_map">
                    <Form.Label className="form-label">Merchant's Link in Google Map <span className="form-required">*</span></Form.Label>
                    <div>
                      <p className="form-note-text"> <em> Ex: https://maps.app.goo.gl/nFMmgJLJLmRhgJLu9 </em></p>
                    </div>
                    <Form.Control
                      type="text"
                      name="google_map"
                      value={primaryDetails.google_map || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input${isError.google_map ? " form-input-error" : ""}`}
                    />
                    {isError.google_map && (
                      <div className="form-error">
                        Please enter the Google Map link
                      </div>
                    )}
                  </Form.Group>

                  {/* Merchant's Link Type */}
                  <Form.Group className="mb-5" controlId="link_type">
                    <Form.Label className="form-label">
                      Link Type 
                      <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Select
                      name="link_type"
                      value={primaryDetails.link_type || ""}
                      onChange={handleInputChange}
                      className={`form-input${
                        isError.link_type ? " form-input-error" : ""
                      }`}
                    >
                      <option value="">Select Link Type</option>
                      {MERCHANT_LINK_TYPES.map((type, index) => (
                        <option key={`link-type-${index}`} value={type}>
                          {type}
                        </option>
                      ))}
                    </Form.Select>
                    {isError.link_type && (
                      <div className="form-error">
                        Please select a merchant's link type
                      </div>
                    )}
                  </Form.Group>

                  <div className="form-btn-row">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleSubmit} variant="next" className="form-btn variant-primary" disabled={!isFormValid()}>
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MerchantLocation;
